import { INFOMANIAK_SERVICE_IDS } from './infomaniak-service-ids.enum';
import servicesConfiguration from '@infomaniak/config-services';
import { IConfigService } from '@infomaniak/config-services/dist/typings';

export function getServiceConfiguration(
  serviceId: INFOMANIAK_SERVICE_IDS,
): IConfigService | undefined {
  return servicesConfiguration.config()[serviceId];
}

export function getServiceConfigurationOrThrow(
  serviceId: INFOMANIAK_SERVICE_IDS,
): IConfigService {
  const config: IConfigService | undefined = getServiceConfiguration(serviceId);
  if (config === void 0) {
    throw new Error(`Invalid serviceId`);
  } else {
    return config;
  }
}
